// src/components/OreInCorso.js
// In Home, solo quando il tempo di «Le mie ore» sta girando: su cosa e da quanto, con il
// collegamento per tornarci (fermare, cambiare commessa). Altrimenti non mostra nulla.
import React, { useEffect, useState } from "react";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../contexts/AuthContext";
import { useOrg } from "../contexts/OrgContext";
import { cronometro, oraDi, giornoDi, UFFICIO } from "../utils/diarioOre";

export default function OreInCorso({ onNavigate }) {
  const { currentUser } = useAuth();
  const { effectiveOrgId: orgId } = useOrg();
  const uid = currentUser?.uid;
  const [b, setB] = useState(null);
  const [adesso, setAdesso] = useState(Date.now());
  useEffect(() => {
    if (!orgId || !uid) return undefined;
    return onSnapshot(query(collection(db, "diarioOre"), where("orgId", "==", orgId), where("uid", "==", uid), where("inCorso", "==", true)),
      s => setB(s.docs.map(d => ({ id: d.id, ...d.data() })).sort((x, y) => (y.inizio || 0) - (x.inizio || 0))[0] || null), () => setB(null));
  }, [orgId, uid]);
  useEffect(() => {
    if (!b) return undefined;
    const t = setInterval(() => setAdesso(Date.now()), 1000);
    return () => clearInterval(t);
  }, [b]);
  if (!b) return null;
  const vecchio = b.data && b.data < giornoDi(adesso);
  const su = b.projectId ? `${b.codiceCommessa ? b.codiceCommessa + " · " : ""}${b.projectNome || "Commessa"}` : UFFICIO.nome;
  return (
    <button type="button" onClick={() => onNavigate({ page: "le-mie-ore" })}
      style={{ display: "flex", alignItems: "center", gap: 12, width: "100%", textAlign: "left", background: "#1e1b4b", color: "#fff", border: "none",
        borderRadius: 14, padding: "12px 16px", marginBottom: 14, cursor: "pointer", fontFamily: "'Inter',sans-serif" }}>
      <span style={{ fontSize: 22 }}>⏱️</span>
      <span style={{ flex: 1, minWidth: 0 }}>
        <span style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#c4b5fd", letterSpacing: ".04em" }}>
          {vecchio ? "LE MIE ORE · TEMPO RIMASTO ACCESO" : `LE MIE ORE · DALLE ${oraDi(b.inizio)}`}
        </span>
        <span style={{ display: "block", fontSize: 14, fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{su}</span>
      </span>
      <span style={{ fontSize: 20, fontWeight: 900, fontVariantNumeric: "tabular-nums" }}>{vecchio ? "Sistema ›" : cronometro(adesso - b.inizio)}</span>
    </button>
  );
}
